import { connect } from 'react-redux'
import { Navigate } from 'react-router-dom'

const mapStateToProps = ({ auth }) => ({ token: auth.token, needChgPwd: auth.needChgPwd })

const Redirect = ({ token, needChgPwd }) => {
  if (needChgPwd) {
    return <Navigate to="/reset_password" replace />
  }

  return <Navigate to={`/${token ? '/account' : '/login'}`} replace />
}

export default connect(mapStateToProps)(Redirect)
